// Port of api/fuel/app/classes/controller/api/monty/views/default.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import Config from 'offline/model/config'

function contextId(context) {
	if (context === 'collection') return 1
	if (context === 'ratings') return 2
	if (context === 'plays') return 3
	if (context === 'gameplays') return 4
	return 0
}

function viewToArray(row) {
	var fields = row.view_fields || []
	if (typeof fields === 'string') {
		try { fields = JSON.parse(fields) } catch (e) { fields = [] }
	}
	return {
		id: parseInt(row.view_id, 10) || 0,
		default: parseInt(row.view_default, 10) || 0,
		type: parseInt(row.view_type, 10) || 0,
		context: parseInt(row.view_context, 10) || 0,
		public: parseInt(row.view_public, 10) || 0,
		name: row.view_name,
		fields: fields
	}
}

export default function(params) {
	var userId = params.sessionUserId || DB.meta('sync_user_id') || false
	var context = params.context
	var view = params.view
	var id = contextId(context)

	if (!userId) {
		return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
	}

	DB.run('UPDATE view SET view_default = 0 WHERE user_id = ? AND view_context = ?', [userId, id])

	if (!isNaN(parseInt(view, 10))) {
		DB.run('UPDATE view SET view_default = 1 WHERE user_id = ? AND view_context = ? AND view_id = ?', [userId, id, parseInt(view, 10)])
	}

	var config = Config.user(userId)
	if (!config[context]) config[context] = {}
	config[context].layout = view

	var existing = DB.query('SELECT config_id FROM config WHERE user_id = ?', [userId])
	if (existing.length) DB.run('UPDATE config SET config_data = ? WHERE user_id = ?', [JSON.stringify(config), userId])
	else DB.run('INSERT INTO config (user_id, config_data) VALUES (?, ?)', [userId, JSON.stringify(config)])

	var views = DB.query('SELECT * FROM view WHERE view_context = ? AND user_id = ?', [id, userId]).map(viewToArray)

	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: {
				views: views,
				config: config
			}
		}
	})
}
